import { getAllPartnersLogos } from '../../service/logo.service';
import { Box, Typography } from '@mui/material';
import { Wallet } from '@mui/icons-material';

const PartnersShowcase = () => {
  const partnerList = getAllPartnersLogos();
  return (
    <>
      <Box
        justifyContent="center"
        alignItems="center"
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: '100% ',
          transform: 'translateY(-50%)',
        }}
      >
        <Box
          display={'flex'}
          justifyContent="space-between"
          alignItems="center"
          flexDirection="row"
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            width: '823px',
            maxHeight: '102px',
            borderRadius: '24px 24px 0 0',
            padding: '1rem 2rem',
          }}
        >
          {partnerList.map((partner) => (
            <Box
              key={partner.id}
              sx={{ maxWidth: '438px' }}
              display={'flex'}
              justifyContent="space-between"
              alignItems="center"
            >
              {partner.component.light}
            </Box>
          ))}
          <Box />

          <Box
            display={'flex'}
            justifyContent="center"
            alignItems="center"
            flexDirection="row"
          >
            <Wallet />

            <Typography sx={{ maxWidth: '135px', marginLeft: '8px' }}>
              Parcelamos em até 12x sem juros
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        justifyContent="center"
        alignItems="center"
        sx={{
          display: { xs: 'flex', md: 'none' },
          width: '80% ',
          margin: '0 auto',
          transform: 'translateY(-50%)',
        }}
      >
        <Box
          display={'flex'}
          justifyContent="space-between"
          alignItems="center"
          flexDirection="row"
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            width: '100%',
            maxHeight: '102px',
            borderRadius: '12px 12px 0 0',
            padding: '1rem 2rem',
          }}
        >
          <Wallet />
          <Typography
            variant="body1"
            sx={{ marginLeft: '1rem', fontSize: '.9rem' }}
          >
            Parcelamos em até 12x sem juros
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default PartnersShowcase;
